import React from 'react'

export default function Banner() {
    return (
        <div className="container cta">
            <div className="row">
                <div className="col-md-9">
                    <h3>Background Search Anyone</h3>
                    <p>We work every day to make pulling background checks with Instant Checkmate easy and informative. <br />Try doing a search on your family, friends, or neighbors. You might be surprised by what you discover.</p>
                </div>
                <div className="col-md-3">
                    <a className="btn btn-md btn-primary animated fadeIn" href="https://www.instantcheckmate.com/" role="button">Search Anyone</a>
                    <p className="center"><span>Try Instant Checkmate Public Records Search</span></p>
                </div>
            </div>
        </div>
    )
}